import { type t } from 'i18next';
import * as yup from 'yup';

export function buildYupLocale(translate: typeof t) {
  yup.setLocale({
    mixed: {
      required: translate('errors.required'),
    },
    string: {
      email: translate('errors.email not valid'),
      matches: translate('errors.not match'),
    },
  });
}
